import { useMemo } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { CreationPetitionUpdate } from '#src/app/pages/petitionDetails/shared/types';

export function useCreationUpdate(): CreationPetitionUpdate {
	const {
		data: { petition: details },
	} = usePetitionDetailsPageData();

	return useMemo(() => {
		const { createdAt, organization, user } = details;
		const displayName = organization ? organization.name : user.displayName;
		return {
			id: '__creation_fake_id__',
			type: 'creation' as const,
			createdAt,
			displayName,
		} as CreationPetitionUpdate;
	}, [details]);
}
